// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"38aed47c","239":"f473d8bd","429":"41e51128","455":"292c7153","463":"a2445f11","488":"e9f6a6a8","977":"99cec930"}[chunkId] + ".chunk.js";
};